import type { CommandHistory } from "@/commands/CommandHistory";
import type { CurvaDocument, DocumentViewport } from "@/document/model/document";
import { documentStore, selectionStore, viewStore } from "@/editor/store";
import { cameraFromDocumentViewport } from "@/editor/shell/canvasGeometry";
import type { LiveEditorSnapshot } from "./documentSession";

export interface HydrateLiveSnapshotTargets {
  setHistory: (history: CommandHistory) => void;
  setViewport: (viewport: DocumentViewport) => void;
  setDocumentRef?: (document: CurvaDocument) => void;
  /** Clears ephemeral UI tied to the previous document (previews, menus, animation chrome). */
  resetScopedState: () => void;
}

/**
 * Apply a parked session into the live editor singletons / refs.
 * Does not touch `workspaceStore` — call after `switchTo` / `openSession` / `closeSession`.
 */
export function hydrateLiveSnapshot(
  snapshot: LiveEditorSnapshot,
  targets: HydrateLiveSnapshotTargets,
): void {
  const document: CurvaDocument = {
    ...snapshot.document,
    viewport: { ...snapshot.viewport },
  };

  targets.setHistory(snapshot.history);
  targets.setViewport({ ...snapshot.viewport });
  targets.setDocumentRef?.(document);
  documentStore.setDocument(document);
  selectionStore.setSelection(snapshot.selection);
  selectionStore.setActiveTool(snapshot.tool.activeTool);
  selectionStore.setSelectedShapeKind(snapshot.tool.selectedShapeKind);
  viewStore.setCamera(cameraFromDocumentViewport(snapshot.viewport));
  targets.resetScopedState();
}
